export enum UploadCompanyCategoryType {
  SubscriptionReport = 'Boletim de subscrição',
  InvestimentPromise = 'Compromisso de investimento',
  FoundRule = 'Regulamento do fundo',
  RegistrationForm = 'Ficha cadastral',
  Taxinformation = 'Informações fiscais',
  AdhesionContract = 'Termo de adesão',
  SignatureCard = 'Cartão de assinaturas',
  IdentificationDocument = 'Documentos de identificação do representante',
  ResidenceProof = 'Comprovantes de endereço',
  AttorneyLetter = 'Procuração',
  AuthorizationTerm = 'Termo de autorização',
  SocialDocument = 'Documentos societários',
  Others = 'Outros',
  ElectionMinutes = 'Ata de Eleição de Diretoria',
  InternalPolicies = 'Manuais e Políticas Internas',
  DueDiligence = 'Questionário de Due Diligence',
  OwnershipDocument = 'Documento de posse dos diretores',
  FinancialStatements = 'Demonstrações Financeiras Padronizadas',
  AuditedFinancialStatements = 'Demonstrações Financeiras auditadas ou assinadas por um contador',
  Chart = 'Organograma'
}
